import {BannerParams} from '../config/BannerParams';
import {BannerTransport} from '../transport/BannerTransport';
import {log} from '../util/BannerCommon';
import {BannerConstant} from '../util/BannerConstant';

export type IAddRequestParams = Record<string, string> | null | undefined;

export class HookBannerParams extends BannerParams {
    position: string;
    companyOwner: boolean;
    withSiteZone: boolean;
    groupName: string | null = null;
    groupDescription: string | null = null;
    groupAvatarUrl: string | null = null;
    useAppsCustomTitle = false;
    addRequestParams: IAddRequestParams;
    appShortName: string | null = null;
    delay = 0;
    width = 0;
    siteZone: string | null = null;
    sitename: string | null = null;
    adblockWhitelist = false;
    useAdfTransport = false;
    /**
     * Флаг, что слоты 350 и 4246 инвертированы
     */
    inv = false;
    inLayer = false;
    contentId: string | null = null;

    constructor(withUniqueId: boolean, withPersonalData: boolean, withLastApps: boolean, position: string, companyOwner: boolean, withSiteZone: boolean) {
        super(withUniqueId, withPersonalData, withLastApps);
        this.position = position;
        this.companyOwner = companyOwner;
        this.withSiteZone = withSiteZone;
    }


    setPosition(position: string) {
        this.position = position;
    }

    setDelay(delay: number) {
        this.delay = delay;
    }

    setInv(inv: boolean) {
        this.inv = inv;
    }

    getDelay(): number {
        return this.delay;
    }

    setInLayer(inLayer: boolean) {
        this.inLayer = inLayer;
    }

    getInLayer(): boolean {
        return this.inLayer;
    }

    setAdblockWhitelist(adblockWhitelist: boolean) {
        this.adblockWhitelist = adblockWhitelist;
    }

    getAdblockWhitelist(): boolean {
        return this.adblockWhitelist;
    }

    setUseAdfTransport(useAdfTransport: boolean) {
        this.useAdfTransport = useAdfTransport;
    }

    isUseAdfTransport(): boolean {
        return this.useAdfTransport;
    }

    getPosition(): string {
        return this.position;
    }

    isCompanyOwner(): boolean {
        return this.companyOwner;
    }

    isAdblockWhitelist() {
        return this.adblockWhitelist;
    }

    setAuxGroupParameters(groupName: string, groupDescription: string, groupAvatarUrl: string) {
        this.groupName = groupName;
        this.groupDescription = groupDescription;
        this.groupAvatarUrl = groupAvatarUrl;
    }

    setUseAppsCustomTitle(useAppsCustomTitle: boolean) {
        this.useAppsCustomTitle = useAppsCustomTitle;
    }

    setAddRequestParams(params: IAddRequestParams) {
        this.addRequestParams = params;
    }

    setAppShortName(appShortName: string) {
        this.appShortName = appShortName;
    }

    getWidth(): number {
        return this.width;
    }

    setWidth(width: number) {
        this.width = width;
    }

    setSiteZone(siteZone: string) {
        this.siteZone = siteZone;
    }

    setSitename(sitename: string) {
        this.sitename = sitename;
    }

    asJSON() {
        const params = BannerParams.prototype.asJSON.call(this);
        if (this.isCompanyOwner()) {
            BannerTransport.appendParam(params, "l", "1");
        }
        const banDataProvider = this.getBannerCfg();
        log('[banDataProvider]', banDataProvider);
        let siteZoneParam = null;
        if (this.siteZone) {
            siteZoneParam = this.siteZone;
        } else if (this.withSiteZone && banDataProvider.siteZone) {
            siteZoneParam = banDataProvider.siteZone;
        }
        if (siteZoneParam !== null) {
            BannerTransport.appendParam(params, BannerConstant.SITEZONE_PARAM, siteZoneParam);
        }

        if (banDataProvider.groupId) {
            BannerTransport.appendParam(params, BannerConstant.GROUP_ID_PARAM, banDataProvider.groupId);
        }
        if (banDataProvider.isaMember) {
            BannerTransport.appendParam(params, BannerConstant.IS_GROUP_ACTIVE_MEMBER_PARAM, banDataProvider.isaMember);
        }
        if (this.groupName) {
            BannerTransport.appendParam(params, BannerConstant.GROUP_NAME_PARAM, this.groupName);
        }
        if (this.groupDescription) {
            BannerTransport.appendParam(params, BannerConstant.GROUP_DESCRIPTION_PARAM, this.groupDescription);
        }
        if (this.groupAvatarUrl) {
            BannerTransport.appendParam(params, BannerConstant.GROUP_AVATAR_URL_PARAM, this.groupAvatarUrl);
        }
        if (this.useAppsCustomTitle) {
            BannerTransport.appendParam(params, BannerConstant.APPS_BANNERS_WITH_CUSTOM_TITLE, "1");
        }
        if (this.appShortName) {
            BannerTransport.appendParam(params, BannerConstant.APPS_BANNERS_APP_SHORT_NAME, this.appShortName);
        }

        if (this.getWidth() > 0) {
            BannerTransport.appendParam(params, "w", this.getWidth() + '');
        }

        if (this.adblockWhitelist) {
            BannerTransport.appendParam(params, 'd', '1');
        } else {
            if (this.inv) {
                BannerTransport.appendParam(params, 'inv', '1');
            }
        }

        if (this.sitename) {
            BannerTransport.appendParam(params, 'sitename', this.sitename);
        }

        if (this.contentId) {
            BannerTransport.appendParam(params, 'content_id', this.contentId);
        }

        const requestParams = this.addRequestParams;
        if (requestParams) {
            for (let paramName in requestParams) {
                if (requestParams.hasOwnProperty(paramName)) {
                    BannerTransport.appendParam(params, paramName, requestParams[paramName]);
                }
            }
        }

        return params;
    }
}
